<script>
import { ref } from 'vue'

export default {
  setup(props, { slots }) {
    const active = ref(false)
    const toggle = () => active.value = ! active.value

    return () => slots.default({
      active: active.value,
      toggle
    })
  }
}
</script>